export const Permission_type = {
   start_entry:"start_entry",
   upload_task:"upload_task",
   create_invoice:"create_invoice",
   approve_payment:"approve_payment",
   add_vendor:"add_vendor",
   add_orders:"add_orders",
   disable_entry:"disable_entry",
   edit_price:"edit_price",
  };